import { Icon24Eyedropper } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '../../types/SvgComponent';

const EyeDropIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        d="M17.1029 10.6099L17.5604 11.0683C17.6998 11.2076 17.8103 11.373 17.8857 11.555C17.9611 11.737 17.9999 11.9321 17.9999 12.1291C17.9999 12.3261 17.9611 12.5212 17.8857 12.7032C17.8103 12.8852 17.6998 13.0506 17.5604 13.1899L16.7167 14.0336C16.576 14.1742 16.3854 14.2531 16.1865 14.2531C15.9877 14.2531 15.797 14.1742 15.6564 14.0336L9.9695 8.34393C9.82895 8.20329 9.75 8.0126 9.75 7.81378C9.75 7.61495 9.82895 7.42426 9.9695 7.28362L10.8132 6.43987C10.9525 6.30055 11.1179 6.19003 11.2999 6.11462C11.4819 6.03922 11.677 6.00041 11.874 6.00041C12.071 6.00041 12.2661 6.03922 12.4481 6.11462C12.6301 6.19003 12.7955 6.30055 12.9348 6.43987L13.3932 6.89737L15.737 4.54425C16.7486 3.53268 18.3967 3.47081 19.4345 4.4505C19.6896 4.69154 19.8938 4.98129 20.035 5.30261C20.1761 5.62393 20.2514 5.9703 20.2564 6.32124C20.2614 6.67217 20.196 7.02054 20.064 7.34574C19.932 7.67094 19.7361 7.96637 19.4879 8.21456L17.1029 10.6099Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9351 13.307L9.62132 18.6217C9.23597 19.0084 8.75244 19.2825 8.2228 19.4147C7.69317 19.5468 7.13751 19.532 6.6157 19.3717L4.7407 20.1911C4.60255 20.2515 4.4494 20.2689 4.30123 20.241C4.15306 20.2131 4.01674 20.1411 3.91007 20.0345C3.83353 19.958 3.78184 19.8602 3.76177 19.7538C3.7417 19.6474 3.75418 19.5375 3.79757 19.4383L4.65914 17.4639C4.48027 16.934 4.45308 16.3647 4.58064 15.8202C4.70819 15.2757 4.98542 14.7777 5.38101 14.3824L10.6957 9.0686"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const EyeDropIcon = fplIcon(EyeDropIconLocal, Icon24Eyedropper);
